class MenuDrawerCategorySlider {
  constructor() {
    this.init();
  }

  init = () => {
    this.slider();
  }

  slider = () => {
    if (document.querySelector('.menu-drawer-category-js')) {
      let swiper = new Swiper('.menu-drawer-category-js', {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: '.menu-drawer-category-js .swiper-button-next',
          prevEl: '.menu-drawer-category-js .swiper-button-prev',
        }
      });
    }
  };
}

if (document.querySelectorAll(".menu-drawer-category-js")) {
  new MenuDrawerCategorySlider();
}
